// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { AccountOperationInfoMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { AccountOperationMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { AccountStatusMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { AlertMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { AlgorithmGainersLosersMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { AlgorithmHighLowMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { AlgorithmMarketConsensusMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { AlgorithmsAvailableMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { AlgorithmSubscribeMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { AlgorithmTopVolumeMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { AssetTypeMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { BMCounterMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { BMHistoryResponseMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { BrandingRulesMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { BrokerMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { BrokerMessageResponseCaseMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { BusinessRejectMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { ChangePasswordMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { ChangeTradingPasswordMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { ClosePositionMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { CompressedMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { ControlAlertCommandMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { CrossRateMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { CrossRatesPlanMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { CustodialPlanMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { CustomListMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { EntitlementProductDocumentResponseMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { EntitlementProductMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { EntitlementProductSubscriptionResponseMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { ExternalLinkMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { ExternalLinkRemoveMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { FundingRateMarkupPlanMessageProcessor } from "../MessageProcessors/FundingRateMarkupPlanMessageProcessor.js"
import { HelloMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { InformationMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { InputInitDataRequstMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { InstrumentDayBarMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { InstrumentMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { InstrumentPricesMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { InstrumentTypeMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { InstrumentUpdateMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { LogonMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { LogoutMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { MarginCallMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { MarginResponseMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { MessageProcessorBase } from "../MessageProcessors/ProcessorsImport.js"
import { NewsMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { NewsSubscribeResponseProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { NonFixedInstumentListResponseMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { NonFixedInstumentStrikesResponseMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { OneTimePasswordMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { OpenOrderMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { OrderDialogMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { PasswordRecoveryChangeMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { PFixHistoryMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { PingMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { PortfolioInvestorMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { PortfolioModelMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { PortfolioRealtimeStatisticsMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { PortfolioStatisticsMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { PortfolioSystemMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { PositionMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { PropertyMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { Quote1MessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { Quote2AggregatedMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { Quote2MessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { Quote3MessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { Quote4MessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { RefreshTokenProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { ReplaceAlertMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { ReportGroupResponseMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { ReportTypeMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { RevenuePlanMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { RiskPlanMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { RiskWarningMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { RouteMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { SessionMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { SessionSwitchMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { SnapshotResponseMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { SOAPMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { SourceListProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { SubscribeMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { SubscriptionStrategyMessageProccesor } from "../MessageProcessors/ProcessorsImport.js"
import { SubscriptionStrategyRequestMessageProccesor } from "../MessageProcessors/ProcessorsImport.js"
import { TokenVerifyResponseMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { TradeMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { TradeSessionStatusMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { TradingSignalCancelMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { TradingSignalMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { TradingSignalRequestMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { TradingSignalSeenRequestMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { TradingSystemMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { TradingSystemRemoveMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { TradingUnlockResponseProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { UserGroupMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { XMLMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { YTMMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { PriceLimitsMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { CloseAccountResponseMessageProcessor } from "../MessageProcessors/ProcessorsImport.js"
import { Message } from "../Messages/Message.ts"
import { AlgorithmHistoricalGainersLosersTopsMessageProcessor } from "../MessageProcessors/Algorithm/AlgorithmHistoricalGainersLosersTopsMessageProcessor.ts"
export let MsgDecoder = function (pfixMsgProcessor)
{
    this.parent = pfixMsgProcessor || null
    let parent = this.parent

    this.FProcTable = new Object()

    this.FProcTable[Message.CODE_PFIX_LOGON_MESSAGE] = new LogonMessageProcessor(this)
    this.FProcTable[Message.CODE_PFIX_HELLO_MESSAGE] = new HelloMessageProcessor()
    this.FProcTable[Message.CODE_ACCOUNTSTATUS] = new AccountStatusMessageProcessor()
    this.FProcTable[Message.CODE_INSTRUMENT] = new InstrumentMessageProcessor(this)
    this.FProcTable[Message.CODE_INSTRUMENT_LIST_RESPONSE] = new NonFixedInstumentListResponseMessageProcessor(this)
    this.FProcTable[Message.CODE_QUOTE] = new Quote1MessageProcessor(this, parent)
    this.FProcTable[Message.CODE_QUOTE2] = new Quote2MessageProcessor(this)
    this.FProcTable[Message.CODE_QUOTE3] = new Quote3MessageProcessor(this)
    // this.FProcTable[Message.CODE_QUOTE4] = new Quote4MessageProcessor(this, parent)
    this.FProcTable[Message.CODE_SUBSCRIBE_RESPONSE_MESSAGE] = new SubscribeMessageProcessor(this)
    this.FProcTable[Message.CODE_PFIX_PING_MESSAGE] = new PingMessageProcessor()
    this.FProcTable[Message.CODE_INSTRUMENT_TYPE] = new InstrumentTypeMessageProcessor()
    this.FProcTable[Message.CODE_OPENORDER] = new OpenOrderMessageProcessor(this)
    this.FProcTable[Message.CODE_OPENPOSITION] = new PositionMessageProcessor(this)
    this.FProcTable[Message.CODE_CLOSEPOSITION] = new ClosePositionMessageProcessor(this)
    this.FProcTable[Message.CODE_INSTRUMENT_DAY_BAR] = new InstrumentDayBarMessageProcessor(this)
    this.FProcTable[Message.CODE_INSTRUMENT_PRICES] = new InstrumentPricesMessageProcessor(this)
    this.FProcTable[Message.CODE_CROSSRATE_MESSAGE] = new CrossRateMessageProcessor(this)
    this.FProcTable[Message.CODE_CROSSRATES_PLAN_MESSAGE] = new CrossRatesPlanMessageProcessor()
    this.FProcTable[Message.CODE_TRADE] = new TradeMessageProcessor(this)
    this.FProcTable[Message.CODE_PFIX_PROPERTY_MESSAGE] = new PropertyMessageProcessor(this)
    this.FProcTable[Message.CODE_SOURCE_LIST] = new SourceListProcessor(this)
    this.FProcTable[Message.CODE_REPORT_TYPE_MESSAGE] = new ReportTypeMessageProcessor()
    this.FProcTable[Message.CODE_ASSET_TYPE_MESSAGE] = new AssetTypeMessageProcessor()
    this.FProcTable[Message.CODE_SESSION_MESSAGE] = new SessionMessageProcessor()
    this.FProcTable[Message.CODE_INIT_DATA_REQUEST] = new InputInitDataRequstMessageProcessor()
    this.FProcTable[Message.CODE_ROUTE] = new RouteMessageProcessor(this)
    this.FProcTable[Message.CODE_NEW_ORDER_MESSAGE] = new OrderDialogMessageProcessor(this)
    this.FProcTable[Message.CODE_PFIX_HISTORY_RESP] = new PFixHistoryMessageProcessor()
    this.FProcTable[Message.CODE_PFIX_RISK_PLAN_MESSAGE] = new RiskPlanMessageProcessor(this)
    this.FProcTable[Message.CODE_PFIX_XML_MESSAGE] = new XMLMessageProcessor()
    this.FProcTable[Message.CODE_PFIX_QUOTE2_AGGREGATED] = new Quote2AggregatedMessageProcessor(this)
    this.FProcTable[Message.CODE_PFIX_COMPRESSED_MESSAGE] = new CompressedMessageProcessor(this)
    this.FProcTable[Message.CODE_TRADE_SESSION_STATUS_MESSAGE] = new TradeSessionStatusMessageProcessor()
    this.FProcTable[Message.CODE_BUSINESS_REJECT_MESSAGE] = new BusinessRejectMessageProcessor()
    this.FProcTable[Message.CODE_INSTRUMENT_STRIKES_RESPONSE] = new NonFixedInstumentStrikesResponseMessageProcessor(this);
    this.FProcTable[Message.CODE_PFIX_LOGOUT_MESSAGE] = new LogoutMessageProcessor();
    this.FProcTable[Message.CODE_ONETIME_PASSWORD_MESSAGE] = new OneTimePasswordMessageProcessor();
    this.FProcTable[Message.CODE_TRADING_UNLOCK_MESSAGE_RESPONSE] = new TradingUnlockResponseProcessor();
    this.FProcTable[Message.CODE_COMMISSION_PLAN_MESSAGE] = new RevenuePlanMessageProcessor();
    this.FProcTable[Message.CODE_SPREAD_PLAN_MESSAGE] = new RevenuePlanMessageProcessor();
    this.FProcTable[Message.CODE_PFIX_TRADE_INSTRUMENT] = new InstrumentUpdateMessageProcessor(this);
    this.FProcTable[Message.CODE_YTM_RESPONSE] = new YTMMessageProcessor();
    this.FProcTable[Message.CODE_TRADING_SIGNALS_REQ_MESSAGE] = new TradingSignalRequestMessageProcessor();
    this.FProcTable[Message.CODE_TRADING_SIGNAL_REQ_SEEN_MESSAGE] = new TradingSignalSeenRequestMessageProcessor();
    this.FProcTable[Message.CODE_TRADING_SIGNAL_MESSAGE] = new TradingSignalMessageProcessor();
    this.FProcTable[Message.CODE_CANCEL_TRADING_SIGNAL_MESSAGE] = new TradingSignalCancelMessageProcessor();
    this.FProcTable[Message.CODE_TRADING_SYSTEM_MESSAGE] = new TradingSystemMessageProcessor();
    this.FProcTable[Message.CODE_TRADING_SYSTEM_REMOVE_MESSAGE] = new TradingSystemRemoveMessageProcessor();
    this.FProcTable[Message.CODE_SUBSCRIPTION_STRATEGY_MESSAGE] = new SubscriptionStrategyMessageProccesor();
    this.FProcTable[Message.CODE_SUBSCRIPTION_STRATEGY_REQUEST_MESSAGE] = new SubscriptionStrategyRequestMessageProccesor();
    this.FProcTable[Message.CODE_PFIX_CHANGE_PASSWORD_REQUEST] = new ChangePasswordMessageProcessor();
    this.FProcTable[Message.CODE_PFIX_CHANGE_TRADING_PASSWORD_REQUEST] = new ChangeTradingPasswordMessageProcessor();
    this.FProcTable[Message.CODE_TEXT_MESSAGE] = new BrokerMessageProcessor();
    this.FProcTable[Message.CODE_PFIX_BROKER_MESSAGE_RESPONSE_CASE_RESPONSE] = new BrokerMessageResponseCaseMessageProcessor();
    this.FProcTable[Message.CODE_INFORMATION_MESSAGE] = new InformationMessageProcessor();
    this.FProcTable[Message.CODE_USER_GROUP] = new UserGroupMessageProcessor();
    this.FProcTable[Message.CODE_PFIX_REFRESH_TOKEN] = new RefreshTokenProcessor();
    this.FProcTable[Message.CODE_PFIX_BRANDING_RULES_RESP] = new BrandingRulesMessageProcessor();
    this.FProcTable[Message.CODE_PFIX_TRADE_SESSION_SWITCH] = new SessionSwitchMessageProcessor();
    this.FProcTable[Message.CODE_ACCOUNOPERATION_MESSAGE] = new AccountOperationMessageProcessor();
    this.FProcTable[Message.CODE_PFIX_SOAP_RESP] = new SOAPMessageProcessor();
    this.FProcTable[Message.CODE_REPORT_GROUP_RESPONSE] = new ReportGroupResponseMessageProcessor();
    this.FProcTable[Message.CODE_MARGIN_RESP] = new MarginResponseMessageProcessor();
    this.FProcTable[Message.CODE_RISK_WARN_MESSAGE] = new RiskWarningMessageProcessor();
    this.FProcTable[Message.CODE_MARGINCALL] = new MarginCallMessageProcessor();
    this.FProcTable[Message.CODE_PFIX_PORTFOLIO_STATISTICS_RESPONSE] = new PortfolioStatisticsMessageProcessor();
    this.FProcTable[Message.CODE_NEWS_SUBSCRIBE_RESPONSE] = new NewsSubscribeResponseProcessor();
    this.FProcTable[Message.CODE_NEWS_MESSAGE] = new NewsMessageProcessor();
    this.FProcTable[Message.CODE_PFIX_TOKEN_VERIFY_RESPONSE] = new TokenVerifyResponseMessageProcessor();
    this.FProcTable[Message.CODE_GET_SNAPSHOT_RESPONSE] = new SnapshotResponseMessageProcessor();
    this.FProcTable[Message.CODE_PFIX_EXTERNAL_LINK_MESSAGE] = new ExternalLinkMessageProcessor();
    this.FProcTable[Message.CODE_PFIX_EXTERNAL_LINK_REMOVE_MESSAGE] = new ExternalLinkRemoveMessageProcessor();

    this.FProcTable[Message.CODE_PFIX_PORTFOLIO_SYSTEM_MESSAGE] = new PortfolioSystemMessageProcessor();
    this.FProcTable[Message.CODE_PFIX_PORTFOLIO_INVESTOR_MESSAGE] = new PortfolioInvestorMessageProcessor();
    this.FProcTable[Message.CODE_PFIX_PORTFOLIO_MODEL_MESSAGE] = new PortfolioModelMessageProcessor();
    this.FProcTable[Message.CODE_PFIX_PORTFOLIO_REALTIME_STATISTICS] = new PortfolioRealtimeStatisticsMessageProcessor();
    //Account Operation Message
    this.FProcTable[Message.CODE_ACCOUNT_OPERATION_REQUEST_INFO_MESSAGE] = new AccountOperationInfoMessageProcessor(this);
    this.FProcTable[Message.CODE_PFIX_CUSTODIAL_PLAN_MESSAGE] = new CustodialPlanMessageProcessor(this);

    //Alert Decoders
    this.FProcTable[Message.CODE_ALERT_MESSAGE] = new AlertMessageProcessor();
    this.FProcTable[Message.CODE_REPLACE_ALERT_MESSAGE] = new ReplaceAlertMessageProcessor();
    this.FProcTable[Message.CODE_CONTROL_ALERT_COMMAND_MESSAGE] = new ControlAlertCommandMessageProcessor();

    // Product
    this.FProcTable[Message.CODE_PFIX_PRODUCT_MESSAGE] = new EntitlementProductMessageProcessor();
    this.FProcTable[Message.CODE_PFIX_PRODUCT_DOCUMENT_RESP] = new EntitlementProductDocumentResponseMessageProcessor();
    this.FProcTable[Message.CODE_PFIX_PRODUCT_SUBSCRIPTION_MANAGEMENT_RESP] = new EntitlementProductSubscriptionResponseMessageProcessor();

    this.FProcTable[Message.BM_HISTORY_RESPONSE] = new BMHistoryResponseMessageProcessor();
    this.FProcTable[Message.BM_COUNTER_MESSAGE] = new BMCounterMessageProcessor();

    this.FProcTable[Message.CODE_PRICE_LIMITS_MESSAGE] = new PriceLimitsMessageProcessor();
    this.FProcTable[Message.CUSTOM_LIST_MESSAGE] = new CustomListMessageProcessor();
    // Algorithm
    this.FProcTable[Message.CODE_PFIX_ALGORITHMS_AVAILABLE_MESSAGE] = new AlgorithmsAvailableMessageProcessor();
    this.FProcTable[Message.CODE_PFIX_ALGORITHM_SUBSCRIBE_MESSAGE] = new AlgorithmSubscribeMessageProcessor();
    this.FProcTable[Message.CODE_PFIX_ALGORITHM_HIGH_LOW_MESSAGE] = new AlgorithmHighLowMessageProcessor();
    this.FProcTable[Message.CODE_PFIX_ALGORITHM_GAINERS_LOSERS_MESSAGE] = new AlgorithmGainersLosersMessageProcessor();
    this.FProcTable[Message.CODE_PFIX_ALGORITHM_MARKET_CONSENSUS_MESSAGE] = new AlgorithmMarketConsensusMessageProcessor();
    this.FProcTable[Message.CODE_PFIX_ALGORITHM_TOP_VOLUME_MESSAGE] = new AlgorithmTopVolumeMessageProcessor();
    this.FProcTable[Message.CODE_PFIX_ALGORITHM_HISTORICAL_GAINER_LOSER_TOPS_MESSAGE] = new AlgorithmHistoricalGainersLosersTopsMessageProcessor();

    this.FProcTable[Message.CODE_RECOVERY_CHANGE_RESPONSE] = new PasswordRecoveryChangeMessageProcessor();

    this.FProcTable[Message.CODE_PFIX_FUNDING_RATE_MARKUP_PLAN_MESSAGE] = new FundingRateMarkupPlanMessageProcessor();

    this.FProcTable[Message.CODE_PFIX_CLOSE_ACCOUNT_RESPONSE_MESSAGE] = new CloseAccountResponseMessageProcessor();

    this.FInstrumentDecodeMap = {}
    this.FSymbolDecodeMap = {}
    this.FRouteDecodeMap = {}
    this.FAssetDecodeMap = {}
    this.FIdRouteDecodeMap = {}
    this.FQuoteRouteMap = {}
    this.FSourceDecodeMap = {}
}

Object.defineProperty(MsgDecoder.prototype, 'InstrumentDecodeMap', {
    get: function () { return this.FInstrumentDecodeMap }
})

Object.defineProperty(MsgDecoder.prototype, 'SymbolDecodeMap', {
    get: function () { return this.FSymbolDecodeMap }
})

Object.defineProperty(MsgDecoder.prototype, 'RouteDecodeMap', {
    get: function () { return this.FRouteDecodeMap }
})

Object.defineProperty(MsgDecoder.prototype, 'IdRouteDecodeMap', {
    get: function () { return this.FIdRouteDecodeMap }
})

Object.defineProperty(MsgDecoder.prototype, 'QuoteRouteMap', {
    get: function () { return this.FQuoteRouteMap }
})

Object.defineProperty(MsgDecoder.prototype, 'AssetDecodeMap', {
    get: function () { return this.FAssetDecodeMap }
})

Object.defineProperty(MsgDecoder.prototype, 'SourceMap', {
    get: function () { return this.FSourceDecodeMap }
})

MsgDecoder.prototype.Decode = function (fieldSet)
{
    let code = fieldSet.GetField(0)
    if (!code)
    {
        return null
    }

    let proc = this.FProcTable[code.Value]
    if (!proc)
    {
        return null
    }

    let messages = proc.decode(fieldSet)

    return messages
}

MsgDecoder.prototype.GetSymbolById = function (id)
{
    let map = this.FInstrumentDecodeMap
    return map.hasOwnProperty(id) ? map[id] : ''
}

// Получить идентификатор по символу
MsgDecoder.prototype.GetIdBySymbol = function (symbol)
{
    let map = this.FSymbolDecodeMap
    return map.hasOwnProperty(symbol) ? map[symbol] : -1
}

MsgDecoder.prototype.GetRouteById = function (id)
{
    let map = this.FRouteDecodeMap
    return map.hasOwnProperty(id) ? map[id] : ''
}

MsgDecoder.prototype.GetRouteIdByName = function (name)
{
    let map = this.FIdRouteDecodeMap
    return map.hasOwnProperty(name)
        ? map[name]
        : -1
}

MsgDecoder.prototype.GetRouteQuoteId = function (routeId)
{
    let map = this.FQuoteRouteMap
    return map.hasOwnProperty(routeId)
        ? map[routeId]
        : routeId
}

MsgDecoder.prototype.GetSourceById = function (routeId, sourceId)
{
    let FSourceDecodeMap = this.FSourceDecodeMap
    if (!FSourceDecodeMap.hasOwnProperty(routeId))
    {
        return ''
    }

    let ht = FSourceDecodeMap[routeId]
    if (ht !== null && ht.hasOwnProperty(sourceId))
    {
        return ht[sourceId]
    } else
    {
        return ''
    }
}

MsgDecoder.prototype.FindRequestTime = function (msg)
{
    let parent = this.parent
    return parent ? parent.FindRequestTime(msg) : 0
}